<template>
  <section class="SectionContent" :class="[background, isVertical ? 'vertical' : '']">
    <Wrap class="lg">
      <Headline v-if="headline">
        {{ headline }}
      </Headline>
      <h3 v-if="title" class="title">
        {{ title }}
      </h3>
      <Row :class="{ 'no-gutters': isVertical }">
        <Column v-if="!isVertical && icon" class="icon-column" :sm="size">
          <Icon v-if="icon" :name="icon" />
        </Column>
        <Column class="content" :sm="size">
          <Icon v-if="isVertical && icon" :name="icon" />

          <Markdown
            v-if="content"
            :hasStyles="true"
            :markdown="content" />
          <slot />

          <div class="cta">
            <Route
              v-if="cta"
              class="Btn"
              :class="background === 'blue' ? 'bright' : ''"
              :title="cta"
              :to="ctaTo || { to: $route.name, hash: '#FooterContact' }">
              {{ cta }}
            </Route>
          </div>
        </Column>
      </Row>
    </Wrap>
  </section>
</template>

<script>
const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  components: { Markdown },
  props: {
    background: { type: String, default: 'white' },
    content: String,
    cta: String,
    ctaTo: Object,
    headline: String,
    icon: String,
    isVertical: Boolean,
    title: String,
  },
  computed: {
    size() {
      return (this.isVertical || !this.icon) ? 12 : 6
    },
  },
}
</script>

<style lang="scss">
.SectionContent {
  h3.title {
    margin-bottom: 3rem;
  }

  .content {
    .Markdown {
      h3 {
        font-size: $h35;
      }

      h4 {
        font-size: $h4;
        margin: 3rem 0 0;
      }
    }

    .Btn {
      margin-top: 3rem;
    }
  }

  .content, .icon-column {
    > .Icon {
      color: $main;
      display: block;
      font-size: $h1;
      margin: 2rem 0;
      @include md {
        margin: 3rem 0;
      }
    }
  }

  .icon-column {
    align-items: center;
    display: flex;
    justify-content: center;

    > .Icon {
      display: block;
      font-size: 14rem;
    }
  }

  .cta {
    text-align: center;
  }

  &.blue {
    background-color: $main;
    color: $white;
    @include md {
      background-image: url('../../assets/ellipses-full.png');
      background-position: top left;
      background-repeat: no-repeat;

      &.vertical {
        background-image: none;
      }
    }

    .Headline {
      color: inherit;
    }

    .icon-column > .Icon {
      color: inherit;
    }
  }
}
</style>
